.tab-container {
    background-color: var(--off-white);
    padding-left: 16px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid var(--off-white-dk);
}
